/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Operasional_D1tInputs */

const en_mk_sol_operasional_d1t = /** @type {(inputs: Mk_Sol_Operasional_D1tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The schedule runs the process, not somebody’s memory`)
};

const id_mk_sol_operasional_d1t = /** @type {(inputs: Mk_Sol_Operasional_D1tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadwal menjalankan prosesnya, bukan ingatan orang`)
};

/**
* | output |
* | --- |
* | "The schedule runs the process, not somebody’s memory" |
*
* @param {Mk_Sol_Operasional_D1tInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_operasional_d1t = /** @type {((inputs?: Mk_Sol_Operasional_D1tInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Operasional_D1tInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_operasional_d1t(inputs)
	return en_mk_sol_operasional_d1t(inputs)
});